import { SortDirection } from '../../config/constants';
import { SpoolsAction, SpoolsType } from './spoolsType';

const spoolsReducer = (state: SpoolsType, action: SpoolsAction): SpoolsType => {
    switch (action.type) {
        case 'SET_SEARCH_TERM':
            return {
                ...state,
                searchTerm: action.payload,
            };
        case 'TOGGLE_FILTER_SHOWN':
            return {
                ...state,
                showSelect: {
                    ...state.showSelect,
                    [action.payload]: !state.showSelect[action.payload],
                },
                showSelectDropdown: {
                    ...state.showSelectDropdown,
                    [action.payload]: !state.showSelect[action.payload],
                },
            };
        case 'SET_ACTIVE_SORT':
            return {
                ...state,
                activeSort: action.payload,
            };
        case 'CHANGE_ACTIVE_SORT_DIRECTION':
            return {
                ...state,
                activeSort: {
                    ...state.activeSort,
                    direction:
                        state.activeSort.direction === SortDirection.ASC
                            ? SortDirection.DESC
                            : SortDirection.ASC,
                },
            };
        case 'SET_ACTIVE_FILTER':
            return {
                ...state,
                activeFilter: {
                    ...state.activeFilter,
                    [action.payload.key]: action.payload.value,
                },
            };
        case 'SET_SELECT_DROPDOWN':
            return {
                ...state,
                showSelectDropdown: {
                    ...state.showSelectDropdown,
                    [action.payload.key]: action.payload.value,
                },
            };
        default:
            return {
                ...state,
            };
    }
};

export default spoolsReducer;
